function isImportant(operation) {
    const context = operation.getContext();
    if (context.important === true) {
        return true;
    }
    return false;
}
export default isImportant;
